// extracted by mini-css-extract-plugin
module.exports = {"icon":"ColorPickerView__icon___OM1Dw","icon__text--active":"ColorPickerView__icon__text--active___2mdwU","modal":"ColorPickerView__modal___2AcYc","a":"ColorPickerView__a___2PUhY"};